export const news = [
  {
    id: "premiere-after-rain",
    title: "《雨停之后》定档12月，天海翼挑战全新都市角色",
    date: "2025-10-10",
    type: "新闻",
    source: "天海翼影视内容站",
    cover: "https://readdy.ai/api/search-image?query=press%20conference%20stage%20with%20warm%20spotlights%20and%20dark%20background%2C%20cinematic%20event%20atmosphere%2C%20no%20text&width=800&height=500&seq=thyi-news-01&orientation=landscape",
    excerpt: "由高仁执导、天海翼领衔主演的都市情感剧《雨停之后》正式宣布定档12月，官方同步释出首支预告与人物海报。",
    content: [
      "10月10日，都市情感剧《雨停之后》官方正式宣布定档12月，并发布了首支预告片与人物海报。该剧由高仁执导，天海翼领衔主演。",
      "据介绍，天海翼在剧中饰演一位心理咨询师，角色沉稳理性却背负着难以言说的过去。为贴近人物，她在开机前进行了数月的专业体验与台词打磨。",
      "“这是一个关于‘重新学会靠近’的故事。”天海翼在采访中表示，“我希望观众能在雨停之后的那一刻，感受到一点温柔。”",
      "剧集将于12月与观众见面，目前相关话题已在社交平台持续升温。",
    ],
    relatedWorkIds: ["after-rain"],
    popularity: 98,
  },
  {
    id: "interview-2025",
    title: "专访天海翼：从悬疑到温情，我想演得更真实",
    date: "2025-09-22",
    type: "采访",
    source: "光影人物",
    cover: "https://readdy.ai/api/search-image?query=cozy%20interview%20studio%20with%20warm%20lighting%20and%20microphone%20on%20table%2C%20editorial%20portrait%20atmosphere%2C%20no%20text&width=800&height=500&seq=thyi-news-02&orientation=landscape",
    excerpt: "在最新一期专访中，天海翼聊起自己从悬疑题材走向都市情感的转变，以及她对“真实表演”的坚持。",
    content: [
      "从冷峻的悬疑剧到温暖的都市情感，天海翼近年来的作品跨度不小。在这次专访里，她聊起了选择角色的标准。",
      "“我更在意人物有没有真实的呼吸。”她说，“不管题材是什么，只要这个人的处境让我相信，我就愿意去演。”",
      "谈及《雨停之后》中大量的内心戏，天海翼坦言这是她目前最有挑战的一次尝试。“有时候什么都不说，反而是最难演的。”",
      "对于未来，她表示并不急于定型，“我还在学着成为一个更诚实的演员。”",
    ],
    relatedWorkIds: ["after-rain", "northbound"],
    popularity: 93,
  },
  {
    id: "activity-fanmeeting",
    title: "天海翼上海影迷见面会圆满落幕，现场重现经典桥段",
    date: "2025-09-05",
    type: "活动",
    source: "天海翼影视内容站",
    cover: "https://readdy.ai/api/search-image?query=large%20cinema%20auditorium%20with%20audience%20and%20warm%20stage%20lighting%2C%20event%20atmosphere%2C%20no%20text&width=800&height=500&seq=thyi-news-03&orientation=landscape",
    excerpt: "上周末，天海翼现身上海影迷见面会，与数百位观众面对面交流，并现场重现了《无声的证词》中的经典桥段。",
    content: [
      "9月初，天海翼上海影迷见面会如期举行，数百位来自全国各地的影迷到场。",
      "活动上，天海翼不仅分享了几部代表作的幕后故事，还即兴重现了《无声的证词》中的一段经典台词，引发现场阵阵欢呼。",
      "在互动环节，她认真回答了影迷关于表演与角色的提问，并感谢大家多年来的陪伴。",
      "主办方表示，未来将继续举办类似的线下交流活动，让作品与观众之间的距离更近。",
    ],
    relatedWorkIds: ["silent-witness"],
    popularity: 88,
  },
  {
    id: "review-spring-letter",
    title: "《春日来信》口碑走高，天海翼细腻演技获赞",
    date: "2025-08-28",
    type: "新闻",
    source: "影视评论周刊",
    cover: "https://readdy.ai/api/search-image?query=film%20review%20magazine%20flat%20lay%20with%20warm%20tones%2C%20cinema%20ticket%20and%20notebook%2C%20soft%20light%2C%20no%20text&width=800&height=500&seq=thyi-news-04&orientation=landscape",
    excerpt: "随着剧情推进，正在热播的《春日来信》评分持续攀升，天海翼在剧中的细腻表演成为社交平台热议焦点。",
    content: [
      "正在热播的青春爱情剧《春日来信》自开播以来口碑持续走高，多个平台评分稳步上升。",
      "不少观众表示，天海翼在剧中把角色“青涩与成熟之间的分寸”拿捏得恰到好处，尤其是几场无台词的沉默戏份令人印象深刻。",
      "剧评人指出，该剧在类型框架内做出了难得的克制与真诚，而天海翼的表演正是整部作品的情感支点。",
      "随着剧情进入后半程，相关话题讨论度预计还将进一步上升。",
    ],
    relatedWorkIds: ["spring-letter"],
    popularity: 90,
  },
  {
    id: "award-northbound",
    title: "《北行列车》入围年度华语电影展，天海翼首度提名最佳女主角",
    date: "2025-07-15",
    type: "新闻",
    source: "天海翼影视内容站",
    cover: "https://readdy.ai/api/search-image?query=award%20ceremony%20stage%20with%20golden%20lights%20and%20dark%20elegant%20background%2C%20cinematic%2C%20no%20text&width=800&height=500&seq=thyi-news-05&orientation=landscape",
    excerpt: "年度华语电影展公布入围名单，电影《北行列车》入围主竞赛单元，天海翼凭借片中表演首度获得最佳女主角提名。",
    content: [
      "7月中旬，年度华语电影展正式公布入围名单。电影《北行列车》入围主竞赛单元，天海翼凭借片中母亲的表演首度获得最佳女主角提名。",
      "评委会评价她在片中的表演“静水深流，于克制中见力量”。这也是她首次获得电影类表演奖项的提名。",
      "得知消息后，天海翼在社交平台发文致谢：“感谢所有愿意听这个故事的人。”",
      "影片目前仍在部分影院进行特别放映。",
    ],
    relatedWorkIds: ["northbound"],
    popularity: 92,
  },
  {
    id: "interview-director",
    title: "导演沈墨白谈与天海翼合作《春山旧梦》：她让角色活了过来",
    date: "2025-06-30",
    type: "采访",
    source: "光影人物",
    cover: "https://readdy.ai/api/search-image?query=film%20director%20behind%20camera%20on%20a%20movie%20set%2C%20warm%20cinematic%20lighting%2C%20behind%20the%20scenes%2C%20no%20text&width=800&height=500&seq=thyi-news-06&orientation=landscape",
    excerpt: "在一场关于古装剧美学的对谈中，导演沈墨白回顾了与天海翼的数次合作，并高度评价她的表演投入。",
    content: [
      "在近期的一场创作对谈中，导演沈墨白回顾了自己与天海翼在《春山旧梦》《织云记》中的两次合作。",
      "“她会为角色做大量的案头功课，很多时候我还没想到的细节，她已经准备好了。”沈墨白说，“是她让角色真正活了过来。”",
      "两人在东方美学与人物塑造上的共识，被认为是这两部作品成功的关键。",
      "谈及未来是否会有第三次合作，沈墨白笑称“要看有没有合适的故事”。",
    ],
    relatedWorkIds: ["palace-of-spring", "the-weaver"],
    popularity: 85,
  },
  {
    id: "activity-charity",
    title: "天海翼参与公益阅读计划，为乡村学校捐建图书角",
    date: "2025-05-20",
    type: "活动",
    source: "天海翼影视内容站",
    cover: "https://readdy.ai/api/search-image?query=bright%20reading%20room%20with%20bookshelves%20and%20warm%20natural%20light%2C%20charity%20education%20atmosphere%2C%20no%20text&width=800&height=500&seq=thyi-news-07&orientation=landscape",
    excerpt: "作为公益阅读计划的推广大使，天海翼近日走进多所乡村学校，参与图书角的捐建与阅读陪伴活动。",
    content: [
      "5月，天海翼以推广大使身份参与公益阅读计划，先后走进多所乡村学校，与孩子们一起读书、分享故事。",
      "活动期间，她与志愿者共同为学校捐建了多个图书角，并捐赠了一批适合青少年阅读的书籍。",
      "“阅读是一件很安静、但很有力量的事。”天海翼说，“希望能有更多孩子从中找到属于自己的世界。”",
      "主办方表示，该计划将长期推进，覆盖更多地区。",
    ],
    relatedWorkIds: ["song-of-home"],
    popularity: 80,
  },
  {
    id: "news-anniversary",
    title: "《无声的证词》开播一周年，天海翼发文感谢观众",
    date: "2025-03-18",
    type: "新闻",
    source: "天海翼影视内容站",
    cover: "https://readdy.ai/api/search-image?query=anniversary%20celebration%20with%20soft%20warm%20lights%20and%20elegant%20dark%20backdrop%2C%20commemorative%20mood%2C%20no%20text&width=800&height=500&seq=thyi-news-08&orientation=landscape",
    excerpt: "悬疑剧《无声的证词》迎来开播一周年，天海翼在社交平台发文回顾角色，并向一路相伴的观众致谢。",
    content: [
      "3月18日，悬疑剧《无声的证词》迎来开播一周年。天海翼在社交平台发文，回顾了饰演法医顾问林知夏的点滴。",
      "“林知夏教会我，沉默的证据里也有温度。”她写道，“谢谢每一位陪我们一起寻找真相的人。”",
      "该剧播出一年来仍保持着稳定的长尾热度，相关二创与讨论持续不断。",
      "不少观众在评论区留言，期待作品未来能有更多延展。",
    ],
    relatedWorkIds: ["silent-witness"],
    popularity: 83,
  },
];